import {observable} from 'mobx';
import {construct, ModelProperties} from 'utils';

export class PhrasebookWord {
    @observable id!: number;

    constructor(word?: ModelProperties<PhrasebookWord>) {
        if (word) {
            construct(this, word);
        }
    }
}